<template>
  <div v-if="showComponent">
      <font-awesome-icon
      id="font-awesome-icon-edit"
      icon="edit"
      size="sm"
      class="clickable float-right"
      v-if="showEditButton"
      @click="$emit('edit-button-clicked')"
      />
      <div :class="{'edit-mode-background': showEditButton}" class="w-100 edit-mode-background d-flex justify-content-center  align-items-center">
        <p class="text-muted" v-if="showEditButton">Espacio vacio</p>
      </div>
  </div>
</template>

<script>
// Utils
import LmCommonProps from '@/mixins/LmCommonProps'

export default {
  mixins: [LmCommonProps],
  props: {
    showEditButton: {
      type: Boolean,
      default: false
    },
    isVisible: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="sass" scoped>
.edit-mode-background
  height: 100%
</style>
